module.exports = __webpack_public_path__ + "img/tj.1d268953.svg";